import {
  ExclamationTriangleIcon,
  InfoCircledIcon,
} from "@radix-ui/react-icons";
import { CheckCircleIcon, XCircleIcon } from "lucide-react";
import { type ReactNode } from "react";
import { type ExternalToast, toast } from "sonner";

export { toast };

export function successToast(message: ReactNode, options?: ExternalToast) {
  toast.success(message, {
    icon: <CheckCircleIcon className="text-green-600" />,
    dismissible: true,
    ...options,
  });
}

export function errorToast(message: ReactNode, options?: ExternalToast) {
  if (message instanceof Error) {
    message = message.message;
  }
  
  toast.error(message, {
    icon: <XCircleIcon className="text-red-600" />,
    dismissible: true,
    ...options,
  });
}

export function infoToast(message: ReactNode, options?: ExternalToast) {
  toast.info(message, {
    icon: <InfoCircledIcon className="text-xl text-blue-600" />,
    dismissible: true,
    ...options,
  });
}

export function warningToast(message: ReactNode, options?: ExternalToast) {
  toast.warning(message, {
    icon: <ExclamationTriangleIcon className="text-lg text-yellow-600" />,
    dismissible: true,
    ...options,
  });
}

export function toastLoading(message: ReactNode, options?: ExternalToast) {
  const id = toast.loading(message, options);

  const dismiss = (callback?: () => void) => {
    toast.dismiss(id);
    callback?.();
  };

  return {
    success: (message: ReactNode, options?: ExternalToast) =>
      dismiss(() => successToast(message, options)),
    error: (message: ReactNode, options?: ExternalToast) =>
      dismiss(() => errorToast(message, options)),
    warning: (message: ReactNode, options?: ExternalToast) =>
      dismiss(() => warningToast(message, options)),
    info: (message: ReactNode, options?: ExternalToast) =>
      dismiss(() => infoToast(message, options)),
    dismiss,
  };
}
